import React, { useRef, useState } from "react";

interface UploadDocumentoProps {
   label: string;
   tipoDocumento: string;
   obrigatorio?: boolean;
   onUpload: (
      e: React.ChangeEvent<HTMLInputElement>,
      tipo: string
   ) => void;
}

export const UploadDocumento = ({ label, tipoDocumento, obrigatorio = false, onUpload }: UploadDocumentoProps) => {
   const inputRef = useRef<HTMLInputElement>(null);
   const [fileName, setFileName] = useState<string>("");

   const handleClick = () => {
      inputRef.current?.click();
   };

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files && e.target.files.length > 0) {
         const nomes = Array.from(e.target.files).map(file => file.name);
         setFileName(nomes.join(", "));
      }
      onUpload(e, tipoDocumento);
   };

   return (
      <div className="file-upload-wrapper">
         <label className="DocumentosAnexos">
            <span>{label}</span>
            <span className={`documento-requisito ${obrigatorio ? "obrigatorio" : "opcional"}`}>
               {obrigatorio ? "Obrigatório" : "Opcional"}
            </span>
         </label>
         <button
            className="DocumentosAnexos_Botao"
            type="button"
            onClick={handleClick}
            aria-label={`Selecionar arquivo para ${label}`}
         >
            Selecionar Arquivo
         </button>

         <input
            type="file"
            ref={inputRef}
            onChange={handleChange}
            style={{ display: "none" }}
            multiple
            accept="image/*,.pdf"
         />

         {fileName && <div className="file-name">{fileName}</div>}
      </div>
   );
};
